import { Component } from '@angular/core';
import { Router }    from '@angular/router';

import { AdminService }  from '../../services/admins/admin.service';

import { UserSearchComponent } from '../../users/search/user-search.component';

@Component({
  moduleId: module.id,
  selector: 'admin-search',
  templateUrl: '../../users/search/user-search.component.html',
  styleUrls: [ '../../users/search/user-search.component.css' ]
})

export class AdminSearchComponent extends UserSearchComponent {

  constructor(
    protected router: Router,
    protected adminService: AdminService) { super(router, adminService); }

  protected getDetailUrl(): string {

    return '/admin/';
  };

  protected getUserString(): string {

    return 'Admin';
  };
}


// WEBPACK FOOTER //
// ./src/app/admins/search/admin-search.component.ts